import 'dayjs/locale/ru';
import 'dayjs/locale/en';

import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';

dayjs.extend(updateLocale);
dayjs.extend(localeData);
dayjs.extend(utc);
dayjs.locale('ru');
